import { render } from "./RoleIndex.vue?vue&type=template&id=2724619e&scoped=true"
import script from "./RoleIndex.vue?vue&type=script&lang=js"
export * from "./RoleIndex.vue?vue&type=script&lang=js"

import "./RoleIndex.vue?vue&type=style&index=0&id=2724619e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2724619e"]])

export default __exports__